export const LOADING_PROGRAM = 'LOADING_PROGRAM';
export const SEARCH_PROGRAM  = 'END_SEARCH_PROGRAM';
